import React, { FC } from 'react'
import BadgesCard from '../components/scoreboard/badgesCard/BadgesCard'
import HouseholdComparison from '../components/scoreboard/similarHouseholds/HouseholdComparison'
import SwipeableScoreboardGrid from '../components/scoreboard/swipeableScoreboardGrid/SwipeableScoreboardGrid'
import { AchievementsHook } from '../hooks/useAchievements'
import { useBadges } from '../hooks/useBadges'
import { useScoreboard } from '../hooks/useScoreboard'

interface ScoreboardTabProps {
	achievementsHook: AchievementsHook
}

const ScoreboardTab: FC<ScoreboardTabProps> = ({ achievementsHook }) => {
	const data = useScoreboard()
	const badgeHook = useBadges()

	return (
		<>
			<div className='bg-white dark:bg-[#0d2d30] border border-[#c4c4c4] dark:border-[#144448] rounded-xl p-3'>
				<SwipeableScoreboardGrid
					data={data}
					achievementsHook={achievementsHook}
					badgeHook={badgeHook}
				/>
			</div>

			<div className='bg-white dark:bg-[#0d2d30] border border-[#c4c4c4] dark:border-[#144448] rounded-xl p-3'>
				<HouseholdComparison data={data} />
			</div>

			<BadgesCard badgeHook={badgeHook} />
		</>
	)
}

export default ScoreboardTab
